document.querySelector(".popup-close").addEventListener('click', function () {
    HidePopUp();
}, false);

document.querySelector(".popup-overlay").addEventListener('click', function () {
    HidePopUp();
}, false);

document.querySelector(".popup").addEventListener('click', function (e) {
    e.stopPropagation();
    HidePopUp();
}, false);

function ShowPopUp(message) {
    $(".popup .message").html(message);
    document.querySelector(".popup").style.display = 'block';
    document.querySelector(".popup-overlay").style.display = 'block';
}

function HidePopUp() {
    document.querySelector(".popup").style.display = 'none';
    document.querySelector(".popup-overlay").style.display = 'none';
}